// Copyright 2025-2026 Florian Gallon. All Rights reserved.
//
// Public marketing landing page. Rendered chrome-free by the early return in
// src/App.js (no bakery context, logged out, path "/"), and also on the
// /commercial-landing route. All styling is scoped to `.dbk-landing` via
// ./landing.css; the wrapper carries data-theme="light" so the shared design
// tokens resolve to light values regardless of the global app theme — the app
// itself is never affected.
import { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './landing.css';

import LandingNav from './LandingNav';
import Hero from './Hero';
import Features from './Features';
import Comparison from './Comparison';
import Audience from './Audience';
import Pricing from './Pricing';
import Faq from './Faq';
import HowItWorks from './HowItWorks';
import FinalCta from './FinalCta';
import LandingFooter from './LandingFooter';
import ContactModal from './ContactModal';

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export default function CommercialLandingPage({ setView }) {
  const { language, toggleLanguage } = useLanguage();
  const [showContactForm, setShowContactForm] = useState(false);
  const isFr = language === 'fr';

  return (
    <div className="dbk-landing" data-theme="light">
      <LandingNav
        isFr={isFr}
        setView={setView}
        toggleLanguage={toggleLanguage}
        scrollToSection={scrollToSection}
      />

      <main>
        <Hero isFr={isFr} setView={setView} scrollToSection={scrollToSection} />
        <Features isFr={isFr} />
        <Comparison isFr={isFr} />
        <Audience isFr={isFr} />
        <Pricing isFr={isFr} setView={setView} />
        <Faq isFr={isFr} />
        <HowItWorks isFr={isFr} />
        <FinalCta isFr={isFr} setView={setView} />
      </main>

      <LandingFooter
        isFr={isFr}
        setView={setView}
        scrollToSection={scrollToSection}
        onContact={() => setShowContactForm(true)}
      />

      {showContactForm && (
        <ContactModal isFr={isFr} onClose={() => setShowContactForm(false)} />
      )}
    </div>
  );
}
